<template>
  <page-container2>
    <a-row type="flex" style="height: 100%; overflow-y: hidden">
      <a-col flex="400px">100px</a-col>
      <a-col flex="1 1 500px" style="height: 100%; overflow-y: hidden">
        <editor
          v-model:editorValue="code"
          :mode="mode"
          :ref="editorele"
          @debounce-update="sendMessage"
        ></editor>
      </a-col>
      <a-col flex="0 0 400px">100px</a-col>
    </a-row>
  </page-container2>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import Editor from '@/components/code/Editor.vue';

export default defineComponent({
  name: 'codemirrorpage',
  components: {
    Editor,
  },

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  setup(props: any, { emit }: any) {
    const editorele = ref({});
    const code = ref<string>('a = "Hello Word!"');
    const mode = 'python';

    const sendMessage = () => {
      emit('send-message');
    };
    return {
      code,
      editorele,
      mode,
      sendMessage,
    };
  },
});
</script>
